var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgService1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 267,
    height: 137,
    viewBox: "0 0 267 137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 266.16,
    height: 136.08,
    x: 0,
    y: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#D8D8D8",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#040802",
    fillRule: "nonzero",
    d: "M57.3134375,0 C74.9180208,0 88.8708333,5.22213542 99.171875,15.6664062 C109.472917,26.1106771 114.623437,41.545625 114.623437,61.97125 L114.623437,98.18875 C114.623437,113.735198 111.68862,126.365436 105.818984,136.079465 L83.1320225,136.079622 C84.5036129,134.921335 85.7710638,133.638232 86.934375,132.230312 C93.4954167,124.289687 96.7759375,113.235833 96.7759375,99.06875 L96.7759375,60.960625 C96.7759375,46.7522917 93.410625,35.7098958 86.68,27.8334375 C79.949375,19.9569792 70.1605208,16.01875 57.3134375,16.01875 C44.3815625,16.01875 34.5715104,19.9890625 27.8832813,27.9296875 C21.1950521,35.8703125 17.8509375,46.880625 17.8509375,60.960625 L17.8509375,99.06875 C17.8509375,113.364167 21.1526563,124.450104 27.7560937,132.326562 C28.9051136,133.697092 30.1525042,134.948383 31.4982655,136.080436 L8.82306099,136.079465 C2.94102033,126.365436 0,113.735198 0,98.18875 L0,61.97125 C0,41.545625 5.16140625,26.1106771 15.4842187,15.6664062 C25.8070312,5.22213542 39.7501042,0 57.3134375,0 Z M218.609827,3.08 L218.609,136.079 L200.758,136.079 L200.758889,15.0115625 L197.579202,15.0115625 L167.683264,69.788125 L148.202952,69.788125 L184.973889,3.08 L218.609827,3.08 Z",
    mask: "url(#b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService1);
export default __webpack_public_path__ + "static/media/service1.04803c0f48920f46aee8f3929b754800.svg";
export { ForwardRef as ReactComponent };